import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_cycle_checking_sample_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  prev_sample_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_cycle_guid: fromDatatype.GuidDataFieldInterface;
  pic_hdr_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  sample_size: fromDatatype.IntegerDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_cycle_checking_sample_hdr_RowClass implements bl_aat_claim_cycle_checking_sample_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  prev_sample_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_cycle_guid: fromDatatype.GuidDataFieldInterface;
  pic_hdr_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  sample_size: fromDatatype.IntegerDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
}
